export function isUndefinedNullOrFalse(value) {
  return (
    value === undefined &&
    value === null &&
    typeof value == "boolean" &&
    value === false
  )
}
